import { render } from "./selectSlider.vue?vue&type=template&id=ea98f104&scoped=true&ts=true"
import script from "./selectSlider.vue?vue&type=script&lang=ts"
export * from "./selectSlider.vue?vue&type=script&lang=ts"

import "./selectSlider.vue?vue&type=style&index=0&id=ea98f104&lang=less"
import "./selectSlider.vue?vue&type=style&index=1&id=ea98f104&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea98f104"]])

export default __exports__